import React from 'react';
// import PropTypes from 'prop-types';
// import { at } from 'lodash';
// import { useField } from 'formik';
import {
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@mui/material';

export const RadioFieldRHF = ({
  name,
  label,
  options,
  rhf: { control, errors, Controller },
}) => {
  //
  const generateRadioOptions = () => {
    return options.map((singleOption) => (
      <FormControlLabel
        value={singleOption.value}
        label={singleOption.label}
        control={<Radio />}
      />
    ));
  };

  // function _renderHelperText() {
  //   if (isError) {
  //     return <FormHelperText>{error}</FormHelperText>;
  //   }
  // }

  // function _onChange(e) {
  //   setValue(e.target.value);
  //   setForeignValue(e.target.value);
  // }

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <RadioGroup 
            value={field.value || ''} 
            onChange={field.onChange}
            sx={{ pl: 2 }}
          >
            {generateRadioOptions()}
          </RadioGroup>
        )}
      />
      {/* <FormHelperText>
        {errors?.isForeigner && errors.isForeigner.message}
      </FormHelperText> */}
      {/* <small className="text-danger">
        {errors?.role && errors.role.message}
      </small> */}
    </>
  );
};

// SelectField.defaultProps = {
//   data: [],
// };

// SelectField.propTypes = {
//   data: PropTypes.array.isRequired,
// };

export default RadioFieldRHF;
